import type { MetricsResponse } from '../api-types/metrics';

export const transformMetrics = (metricsResponse: MetricsResponse) => {
  return metricsResponse;
};
